







import SpinnerCard from "./SpinnerCard.vue";
import { createComponent, ref, watch } from "@vue/composition-api";
import { Resource } from "@megarax/client/src";
import { DetailActions } from "@megarax/client/src/detail";
import { ResourceItem } from "@megarax/client/src/resources/ResourceItem";
import { useActions } from "@/shared/useMegaraxClient";

interface Props<T extends ResourceItem> {
  resource: Resource<DetailActions<T>>;
  item: T;
}

export default createComponent<Props<ResourceItem>>({
  components: { SpinnerCard },
  props: {
    resource: { required: true },
    item: { required: true },
  },
  setup(props, ctx) {
    const actions = useActions(props.resource);

    const itemDetail = ref<ResourceItem | null>(null);

    var lastRequestIndex = 0;

    watch(
      () => props.item.id,
      async () => {
        const thisRequestIndex = ++lastRequestIndex;

        itemDetail.value = null;
        const detail = await actions.fetchItem(props.item.id!);
        // ignore the results if there is a newer request
        if (lastRequestIndex > thisRequestIndex) return;
        itemDetail.value = detail;
      },
    );

    return {
      itemDetail,
    };
  },
});
